import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemplateCollection } from '../models/template/dto/template-collection';
import { CollectionReloadDisplaysModalComponent } from '../views/collection/components/modals/collection-reload-displays-modal/collection-reload-displays-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalReloadCollectionDisplays {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    collection: TemplateCollection,
    reloadableDisplayIds: string[],
    onSave: (result: any) => void
  ): void {
    ngZone.run(() => {
      const modalRef = ngbModal.open(
        CollectionReloadDisplaysModalComponent,
        ModalUtils.templateCollectionDisplayModalOptions(injector)
      );
      const compInst = modalRef.componentInstance as CollectionReloadDisplaysModalComponent;
      compInst.viewModel.connectToCollection(collection);
      compInst.viewModel.connectToReloadableDisplayIds(reloadableDisplayIds);
      compInst.viewModel.connectToStartingAtStepZero(false);
      modalRef.result.then(result => exists(result) && onSave?.(result)).catch(() => {});
    });
  }
}
